export const getTag = (tagId) => ({ cropTags }) =>
cropTags.tagsList.find(({ id }) => id === tagId);